import React, { memo, useContext, useMemo } from "react";

import {
  Box,
  Collapse,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

import { useState } from "react";

import { withRouter } from "react-router";

import AuthContext from "../../../../Context/Auth/AuthContext";
import {
  AddCircle,
  Cancel,
  Check,
  Create,
  DeleteForever,
  ExpandLess,
  ExpandMore,
  Restore,
} from "@mui/icons-material";

import RowAgregarItem from "../Componentes/RowItems/RowAgregarItem";
import RowItem from "../Componentes/RowItems/RowItem";
import ConfirmacionDialog from "../../../components/Dialogs/ConfirmacionDialog";
import ButtonsAction from "../../../components/Tablas/ButtonsAction";
import TablaCabecera from "../../../components/Tablas/TablaCabecera";
import { trimPropsItem } from "../../../../config/const";
import { usePermiso } from "../../../../hooks/usePermiso";
import {
  useRowStyles,
  butonIconTransition,
} from "../../../../styles/stylesRows";
import { columnasHijo } from "../data";
import clienteAxios from "../../../../config/axios";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
import {
  calcularProducto,
  calcularTotales,
} from "../../../Ventas/Facturas/Componentes/helpers";
const Row = (props) => {
  // CLASES
  const classes = useRowStyles();
  const { mostrarAlerta } = useContext(AlertaContext);
  // PROPS
  const {
    arrayExport,
    setarrayExport,
    row,
    index,
    campoExport,
    socket,
    seteditarFactura,
    changeObjetoActivoStateFactura,
    setopenFactura,
    ObjectoActivoFactura,
  } = props;
  const claseCelda = `${
    index % 2 === 0 ? classes.celda : classes.celdaSecundario
  } ${
    row.editado === true
      ? classes.celdaEditado
      : row.nuevo === true
      ? classes.celdaNuevo
      : row.eliminado === true
      ? classes.celdaEliminado
      : ""
  }`;
  // EDITAR
  const [editar, seteditar] = useState(false);
  // HOOK DE PERMISO
  const { tienePermiso, alertaPermiso } = usePermiso("Surtidores");
  // CONTEXT
  const { usuario } = useContext(AuthContext);
  // ABRE EL DIALOG DE CONFIRMACION
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  // SI SE AGREGA UN ITEM A LA TABLA HIJA
  const [agregarItemLista, setagregarItemLista] = useState(false);

  // EXPANDIR
  const [expandir, setexpandir] = useState(false);
  // COPIA DEL REGISTRO PARA EDITAR
  const [item, setitem] = useState({ ...row });
  // COLUMNAS DE LA TABLA HIJA

  //onChange
  const handleChange = (e) => {
    setitem({ ...item, [e.target.name]: e.target.value });
  };
  // DESHABILITAR BOTON
  const botonDisabled = () => {
    // if (item.nombre_surtidor.trim() === "") {
    if (false) {
      return true;
    }
  };
  // ELIMINAR EL REGISTRO
  const handleEliminar = async (_id) => {
    try {
      socket.current.emit("client:eliminarData", {
        tabla: "surtidor",
        rucempresa: usuario.rucempresa,
        rol: usuario.rol,
        user: usuario.usuario,
        ciuEmpresa: usuario.rucempresa,
        [campoExport]: row[campoExport],
      });
      setopenConfirmDialog(false);
    } catch (error) {}
  };
  const funcSubmit = (agregando) => {
    try {
      if (agregando) {
        socket.current.emit(
          "client:guardarData",
          trimPropsItem({
            ...row,

            tabla: "surtidor",
            rucempresa: usuario.rucempresa,
            rol: usuario.rol,
            user: usuario.usuario + "/+/" + row[campoExport],
            ciuEmpresa: usuario.rucempresa,
            [campoExport]: row[campoExport],
          })
        );
      } else {
        socket.current.emit(
          "client:actualizarData",
          trimPropsItem({
            ...item,
            tabla: "surtidor",
            rucempresa: usuario.rucempresa,
            rol: usuario.rol,
            user: usuario.usuario,
            ciuEmpresa: usuario.rucempresa,
          })
        );
      }

      seteditar(false);
    } catch (error) {}
  };

  // FUNCION PARA EDITAR, ABRE EL MODAL COLOCA EN EDITAR EL MODAL Y CAMBIA EL OBJETO ACTIVO
  const funcionEdit = () => {
    setitem({ ...row });
    seteditar(true);
  };

  const pistolas = useMemo(() => {
    const items = [row.estacion1, row.estacion2, row.estacion3].filter(
      (estacion) => estacion
    );
    return items;
  }, [row]);
  const validarCodigoCombustible = (codigoCombustible) => {
    switch (codigoCombustible) {
      case "58":
        return "0185";
      case "57":
        return "0101";
      case "59":
        return "0121";
      default:
        return "DESCONOCIDO";
    }
  };

  // Ejemplo de uso
  const getInventarioByPistola = async () => {
    try {
      const data = {
        pistola: row.pistola,
        codigoCombustible: validarCodigoCombustible(row.codigoCombustible),
        numeroTanque: row.numeroTanque,
        idRegistro: row.idRegistro,
      };
      console.log(data);

      const response = await clienteAxios.post(
        "/abastecimientos/obtener_item",
        data
      );

      const inventario = response.data.producto;

      return {
        resultado: inventario,
        error: "",
        idAbastecimiento: parseInt(
          response.data.abastecimiento.idAbastecimiento,
          10
        ),
        totInicio: parseFloat(response.data.abastecimiento.totInicio),
        totFinal: parseFloat(response.data.abastecimiento.totFinal),
        total: response.data.abastecimiento.valorTotal.toString(),
      };
    } catch (error) {
      console.log({ error });

      return {
        resultado: null,
        error: error?.response?.data?.msg || "Error al obtener el inventario",
        total: "0",
        idAbastecimiento: 0,
        totFinal: 0,
        totInicio: 0,
      };
    }
  };
  const handleGetNameUser = async (documento) => {
    if (!documento) {
      return;
    }
    try {
      const resUser = await clienteAxios.get(
        `/proveedores/usuario/${documento}`
      );
      mostrarAlerta(resUser.data.data.nombre, "success");
    } catch (error) {
      mostrarAlerta("Hubo un error");
    }
  };

  return (
    <React.Fragment>
      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        categoria="warning"
        titulo={`¿Esta seguro de eliminar este registro?`}
        botones={[
          {
            tooltip: "Se eliminaran los registros",
            texto: "SI",
            funcion: () => {
              handleEliminar();
            },
            disabled: false,
            Icon: DeleteForever,
            color: "error",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Cancelar",
            texto: "NO",
            funcion: () => {
              setopenConfirmDialog(false);
            },
            disabled: false,
            Icon: Cancel,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      <TableRow className={classes.root} component={"form"}>
        {/* boton */}
        <ButtonsAction
          arrayExport={arrayExport}
          setarrayExport={setarrayExport}
          campoExport={campoExport}
          row={row}
          claseCelda={claseCelda}
          ocultarCelda
          botones={[
            {
              tooltip: "Recuperar",
              texto: "",
              funcion: () => {
                if (!tienePermiso("agregar")) {
                  return alertaPermiso("agregar");
                }
                funcSubmit(true);
              },
              // disabled: usuario.usuario !== row.user.split("/+/")[0],
              Icon: Restore,
              color: "success",
              id: 3,
              ocultar: !row.eliminado,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Eliminar Registro",
              texto: "",
              funcion: () => {
                if (!tienePermiso("eliminar")) {
                  return alertaPermiso("eliminar");
                }
                setopenConfirmDialog(true);
              },
              disabled: false,
              Icon: DeleteForever,
              color: "error",
              id: 1,
              ocultar: editar || row.eliminado || true,
              tipo: "icono",
              variante: "contained",
              size: "small",
              // css
              sx: butonIconTransition,
            },
            {
              tooltip: "Editar Registro",
              texto: "",
              funcion: () => {
                if (!tienePermiso("editar")) {
                  return alertaPermiso("editar");
                }
                funcionEdit();
              },
              disabled: false,
              Icon: Create,
              color: "secondary",
              id: 2,
              ocultar: editar || row.eliminado || true,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Cancelar",
              texto: "",
              funcion: () => {
                seteditar(false);
                setitem({ ...row });
                // setItemEdit(itemHijo);
              },
              disabled: false,
              Icon: Cancel,
              color: "error",
              id: 1,
              ocultar: !editar,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Guardar Edición",
              texto: "",
              funcion: () => {
                funcSubmit();
              },
              disabled: botonDisabled(),
              Icon: Check,
              color: "success",
              id: 2,
              ocultar: !editar,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
              submit: true,
            },
            {
              tooltip: "Expandir",
              texto: pistolas.length,
              funcion: () => {
                setexpandir((prev) => !prev);
              },
              disabled: false,
              Icon: expandir ? ExpandLess : ExpandMore,
              color: "secondary",
              id: 3,
              ocultar: true,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
          ]}
        />

        {editar ? (
          <>
            <TableCell size="small" align="center" className={claseCelda}>
              <TextField
                value={item.nombre_surtidor}
                name="nombre_surtidor"
                onChange={(e) => handleChange(e)}
                size="small"
                fullWidth
              />
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              <TextField
                value={item.lado}
                name="lado"
                onChange={(e) => handleChange(e)}
                size="small"
                fullWidth
                select
                SelectProps={{ displayEmpty: true }}
              >
                <MenuItem value="" disabled>
                  Seleccione
                </MenuItem>
                {["A", "B"].map((item) => {
                  return (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
              </TextField>
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              {item.user}
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              {new Date(item.fecReg).toLocaleString("es-ES", {
                weekday: "short",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                minute: "2-digit",
                hour: "2-digit",
              })}
            </TableCell>
          </>
        ) : (
          <>
            {/* <TableCell size="small" align="center" className={claseCelda}>
              {row.codigoCombustible}
            </TableCell> */}
            <TableCell size="small" align="center" className={claseCelda}>
              {new Date(row.fechaHora).toLocaleString("es-ES", {
                weekday: "short",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                minute: "2-digit",
                hour: "2-digit",
              })}
            </TableCell>
            <TableCell
              size="small"
              align="center"
              className={claseCelda}
              sx={{
                color: row.facturado === 0 ? "red" : "",
                fontWeight: row.facturado === 0 ? "bold" : "",
                transitionProperty: "opacity",
                transitionDuration: ".5s",
                ":hover": { opacity: 0.7, cursor: "pointer" },
              }}
              onClick={async () => {
                console.log("hola");

                if (row.facturado === 0) {
                  const res = await getInventarioByPistola();
                  console.log({ res });
                  if (!res.resultado) {
                    return mostrarAlerta(
                      "No se encontro el inventario",
                      "error"
                    );
                  }
                  changeObjetoActivoStateFactura((prev) => {
                    const resProductos = [
                      {
                        cantidad: (
                          res.total / res.resultado.invprecios[0]
                        ).toFixed(3),
                        codigo: res.resultado.invSerie,
                        descripcion: res.resultado.invNombre,
                        valUnitarioInterno: res.resultado.invprecios[0],
                        valorUnitario: res.resultado.invprecios[0],
                        llevaIva: res.resultado.invIva,
                        incluyeIva: res.resultado.invIncluyeIva,
                        recargoPorcentaje: 0,
                        recargo: 0,
                        descPorcentaje: 0,
                        descuento: 0,
                        precioSubTotalProducto: 0,
                        valorIva: 0,
                        costoProduccion: 0,
                      },
                    ].map((productoMap) => {
                      return calcularProducto({
                        producto: productoMap,
                        formPorcentaje: 0,
                        iva: usuario.iva,
                      });
                    });

                    const {
                      venSubTotal12,
                      venSubtotal0,
                      venDescuento,
                      venSubTotal,
                      venTotalIva,
                      venTotal,
                      venCostoProduccion,
                    } = calcularTotales(resProductos, usuario.iva);
                    console.log({
                      ...prev,
                      formPorcentaje: 0,
                      venSubTotal12,
                      venSubtotal0,
                      venDescuento,
                      venSubTotal,
                      venTotalIva,
                      venTotal,
                      venCostoProduccion,
                      venProductos: resProductos,
                    });
                    console.log({
                      ...prev,
                      idAbastecimiento: res.idAbastecimiento,
                      totInicio: res.totInicio,
                      totFinal: res.totFinal,
                      formPorcentaje: 0,
                      venSubTotal12,
                      venSubtotal0,
                      venDescuento,
                      venSubTotal,
                      venTotalIva,
                      venTotal,
                      venCostoProduccion,
                      venProductos: resProductos,
                    });

                    return {
                      ...prev,
                      idAbastecimiento: res.idAbastecimiento,
                      totInicio: res.totInicio,
                      totFinal: res.totFinal,
                      formPorcentaje: 0,
                      venSubTotal12,
                      venSubtotal0,
                      venDescuento,
                      venSubTotal,
                      venTotalIva,
                      venTotal,
                      venCostoProduccion,
                      venProductos: resProductos,
                    };
                  });
                  setopenFactura(true);
                  // ObjectoActivoFactura
                }
              }}
            >
              {row.facturado === 0 ? "SIN FACTURAR" : row.nombreCombustible}
            </TableCell>{" "}
            <TableCell size="small" align="center" className={claseCelda}>
              {row.lado}
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              {row.pistola}
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              {row.numeroTanque === 3
                ? "SUPER"
                : row.numeroTanque === 2
                ? "EXTRA"
                : row.numeroTanque === 1
                ? "DIESEL"
                : "DESCONOCIDO"}
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              ${row.precioUnitario}
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              ${row.valorTotal}
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              {row.galonesCalculados}
            </TableCell>
            {/* <TableCell size="small" align="center" className={claseCelda}>
              {row.tiempo}
            </TableCell> */}
            {/* <TableCell size="small" align="center" className={claseCelda}>
              {row.fechaHora}
            </TableCell> */}
            <TableCell size="small" align="center" className={claseCelda}>
              {row.totInicio}
            </TableCell>
            <TableCell size="small" align="center" className={claseCelda}>
              {row.totFinal}
            </TableCell>
            <TableCell
              size="small"
              align="center"
              className={claseCelda}
              sx={{
                transitionProperty: "opacity",
                transitionDuration: ".5s",
                ":hover": { opacity: 0.7, cursor: "pointer" },
              }}
              onClick={() => handleGetNameUser(row.cedulaCliente)}
            >
              {`${row.cedulaCliente ?? ""} - ${row.nombreCliente ?? ""}`}
            </TableCell>
            <TableCell
              size="small"
              align="center"
              className={claseCelda}
              sx={{
                transitionProperty: "opacity",
                transitionDuration: ".5s",
                ":hover": { opacity: 0.7, cursor: "pointer" },
              }}
              onClick={() => handleGetNameUser(row.usuario)}
            >
              {row.usuario}
            </TableCell>
          </>
        )}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={21}>
          <Collapse in={expandir} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Box display="flex" alignItems="center">
                <Typography variant="body1" component="span">
                  Mangueras:
                </Typography>
                {/* <IconButton
                  size="small"
                  aria-label=""
                  color="secondary"
                  disabled={row.eliminado || pistolas.length === 3}
                  onClick={() => {
                    setagregarItemLista(true);
                  }}
                >
                  <AddCircle />
                </IconButton> */}
              </Box>
              {/* {pistolas.length} */}
              <Table size="small" aria-label="purchases">
                <TablaCabecera
                  input={{ id: "" }}
                  columns={columnasHijo}
                  habilitarOrdenar={false}
                />
                <TableBody component={"div"}>
                  {agregarItemLista ? (
                    <RowAgregarItem
                      item={item}
                      setitem={setitem}
                      setagregarItemLista={setagregarItemLista}
                      socket={socket}
                      pistolaNumero={pistolas.length}
                    />
                  ) : null}
                  {pistolas.map((itemHijo, index) => {
                    return (
                      <RowItem
                        itemHijo={itemHijo}
                        item={item}
                        setitem={setitem}
                        pistolaNumero={index + 1}
                        index={index}
                        key={index}
                        socket={socket}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(Row));
